import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=54f9224d&scoped=true&"
import script from "./OrderItem.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OrderItem.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=54f9224d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f9224d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseClickedCheckbox: require('/usr/www/nuxt/components/Base/BaseClickedCheckbox.vue').default})
